export const ALERT_INITIAL_FILTER_FIELDS = ['name', 'category', 'status']
